module.exports = __webpack_public_path__ + "img/credential-text-niice.c05ab7a984f3ec6f80cd601564c2877e.svg";